import { API_BASE, request } from '../../../api';
import { groupBy } from '../../../contrib/utils';
import { paramsToQueryString } from '../../../contrib/Utils/paramsToQueryString';
import { IAdminTeamHoleResultsStore } from '../../admin/teamHoleResults/store';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';

interface IGetFilter {
  hole: number;
}

export interface ITeamHoleResultsActions {
  get: (
    roundId?: number,
    filter?: IGetFilter,
    force?: boolean
  ) => { teamHoleResults?: IAdminTeamHoleResultsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  get: async (state: IStore, roundId: number, filter?: IGetFilter, force?: boolean) => {
    if (state.teamHoleResults[roundId] && !force) {
      return {
        teamHoleResults: state.teamHoleResults
      };
    }

    const params = { round_id: roundId, ...filter };

    const response = await request.get(
      `${API_BASE}/player/results/teams/holes/${paramsToQueryString(params)}`
    );

    if (response.error) {
      return {
        errors: {
          teamHoleResults: { msg: 'Error retrieving the Round Format Awards by Holes List.' }
        }
      };
    }

    const groupedByFlight = groupBy(response, 'flightId');

    return {
      teamHoleResults: {
        ...state.teamHoleResults,
        [roundId]: groupedByFlight
      }
    };
  }
};

export default actions;
